export default "__VITE_ASSET___dmnnvKm__"